import React, { useState,  } from "react";
import {  Button, Modal, Form,  Steps } from "antd";
import TextInput from "../../ReusableInputs/TextInput";
import TextAreaInput from "../../ReusableInputs/TextAreaInput";
import { AccessoryData } from "../../../@types/productInfo";
import NumberInput from "../../ReusableInputs/NumberInput";
import "./style.css";
import SelectOption from "../../ReusableInputs/SelectOption";

const { Step } = Steps;

interface AcessoryModalProps {
  visible: boolean;
  onClose: () => void;
  name: string;
  caption: string;
  searchText: string;
  category: string;
  description: string;
  meta_description: string;
  meta_title: string;
  accessorylink: string;
  image: string;
  loading: boolean;
  isEditModal: boolean;
  isUpdating: boolean;
  isProcessing: boolean;
  isModalVisible: boolean;
  price: number;
  banner: string;
  ingredient: string;
  height: string;
  width: string;
  length: string;
  weight: string;
  product_type: string;
  productLinkName: string;
  sku: string;
  shorten_name: string;

  setSearchText: (value: string) => void;
  setShorten_name: (value: string) => void; 
  setSku: (value: string) => void;
  setName: (value: string) => void;
  setPrice: (value: number) => void;
  setIngredient: (value: string) => void;
  setCaption: (value: string) => void;
  setDescription: (value: string) => void;
  setMetaDescription: (value: string) => void;
  setMetaTitle: (value: string) => void;
  setAccessoryLink: (value: string) => void;
  setImage: (value: string) => void;
  setBanner: (value: string) => void;
  setHeight: (value: string) => void;
  setWidth: (value: string) => void;
  setLength: (value: string) => void;
  setWeight: (value: string) => void;
  setProductType: (value: string) => void;
  setProductLinkName: (value: string) => void;
  setCategory: (value: string) => void;
  handleFormSubmit: () => void;
  handleFileChangeImage: (
    e: React.ChangeEvent<HTMLInputElement>
  ) => Promise<void>;
  handleFileChangeBanner: (
    e: React.ChangeEvent<HTMLInputElement>
  ) => Promise<void>;
  handleModalCancel: () => void;
  handleModalEditCancel: () => void;
  handleSaveEdit: (accessoryData: AccessoryData) => void;
}

const ProductModal: React.FC<AcessoryModalProps> = ({
  visible,
  onClose,
  isEditModal,
  setPrice,
  price,
  handleSaveEdit,
  handleFileChangeBanner,
  name,
  caption,
  description,
  meta_description,
  meta_title,
  accessorylink,
  ingredient,
  setIngredient,
  setCaption,
  setMetaDescription,
  setName,
  setAccessoryLink,
  setMetaTitle,
  setDescription,
  setImage,
  setBanner,
  banner,
  image,
  setProductLinkName,
  isProcessing,
  isModalVisible,
  loading,
  handleFormSubmit,
  handleFileChangeImage,
  handleModalCancel,
  handleModalEditCancel,
  isUpdating,
  setHeight,
  height,
  setWidth,
  width,
  setLength,
  length,
  setWeight,
  weight,
  setProductType,
  product_type,
  productLinkName,
  category,
  setCategory,
  setSku,
  sku,
  shorten_name,
  setShorten_name
}) => {
  const [form] = Form.useForm();
  const [current, setCurrent] = useState(0);

  const next = () => {
    setCurrent(current + 1);
  };

  const prev = () => {
    setCurrent(current - 1);
  };

  //

  const steps = [
    {
      title: "Step 1",
      content: (
        <>
          <section className="flex flex-col md:flex-row md:space-x-4 w-full">
            <div className="w-1/2 p-2">
              <TextInput
                title="Product Name"
                placeholder="Product Name"
                inputValue={name}
                setInputValue={setName}
              />
            </div>
            <div className="w-1/2 p-2">
              <TextInput
                title="Shorten Name"
                placeholder="Enter Shorten Name"
                inputValue={shorten_name}
                setInputValue={setShorten_name}
              />
            </div>

            
          </section>
          <section className="flex flex-col md:flex-row md:space-x-4 w-full">
            <div className="w-1/2 p-2">
              <NumberInput
                title="Product Price"
                placeholder="Enter The Price"
                inputValue={price}
                setInputValue={setPrice}
              />
            </div>
            <div className="w-1/2 p-2">
              <TextInput
                title="Caption"
                placeholder="Enter Caption"
                inputValue={caption}
                setInputValue={setCaption}
              />
            </div>
          </section>
          <section className="flex flex-col md:flex-row md:space-x-4 w-full">
            <div className="w-1/2 p-2">
              <TextInput
                title="Product Sku Code"
                placeholder="Enter The Produt Sku Code"
                inputValue={sku}
                setInputValue={setSku}
              />
            </div>
            <div className="w-1/2 p-2">
              <TextInput
                title="Ingredient"
                placeholder="Enter Ingredient"
                inputValue={ingredient}
                setInputValue={setIngredient}
              />
            </div>
          </section>

          <TextAreaInput
            title="Description"
            placeholder="Enter Description"
            inputValue={description}
            setInputValue={setDescription}
          />

          <section className="flex flex-col md:flex-row md:space-x-4 w-full">
            <div className="w-1/2 p-2">
              <SelectOption
                title="Product Type"
                value={product_type}
                setValue={setProductType}
                placeholder="Select Product Type"
                options={[
                  { value: "flavour", label: "Flavour" },
                  { value: "cylinders", label: "Cylinders" },
                ]}
              />
            </div>
            <div className="w-1/2 p-2">
              <SelectOption
                title="Category"
                value={category}
                setValue={setCategory}
                placeholder="Select category"
                options={[
                  { value: "PEPSI", label: "PEPSI" },
                  { value: "CLASSIC", label: "CLASSIC" },
                  { value: "ZERO", label: "ZERO" },
                  { value: "FRUITS", label: "FRUITS" },
                ]}
              />
            </div>
          </section>

          <section className="flex flex-col md:flex-row md:space-x-4 w-full">
            <div className="w-1/2 p-2">
              <div className="w-full p-2">
                <label
                  htmlFor="image-upload"
                  className="block text-gray-700 mb-3">
                  Image
                </label>
                <input
                  id="image-upload"
                  type="file"
                  accept="image/*"
                  onChange={handleFileChangeImage}
                />
                {image && (
                  <div className="p-4 w-full">
                    <img
                      src={image}
                      alt="Product Imag"
                      style={{ width: "auto", maxHeight: "100px" }}
                    />
                  </div>
                )}
              </div>
            </div>
            <div className="w-1/2 p-2">
              <div className="w-full p-2">
                <label
                  htmlFor="image-upload"
                  className="block text-gray-700 mb-3">
                  Banner
                </label>
                <input
                  id="image-upload"
                  type="file"
                  accept="image/*"
                  onChange={handleFileChangeBanner}
                />
                {banner && (
                  <div className="p-4 w-full">
                    <img
                      src={banner}
                      alt="Product Imag"
                      style={{ width: "auto", maxHeight: "100px" }}
                    />
                  </div>
                )}
              </div>
            </div>
          </section>
        </>
      ),
    },
    {
      title: "Step 2",

      content: (
        <>
          <section className="flex flex-col md:flex-row md:space-x-4 w-full">
            <div className="w-1/2 p-2">
              <TextInput
                title="Width"
                placeholder="Enter product width"
                inputValue={width}
                setInputValue={setWidth}
              />
            </div>
            <div className="w-1/2 p-2">
              <TextInput
                title="Weight"
                placeholder="Please enter the Product weight!"
                inputValue={weight}
                setInputValue={setWeight}
              />
            </div>
          </section>

          <section className="flex flex-col md:flex-row md:space-x-4 w-full">
            <div className="w-1/2 p-2">
              <TextInput
                title="Height"
                placeholder="Enter product height"
                inputValue={height}
                setInputValue={setHeight}
              />
            </div>
            <div className="w-1/2 p-2">
              <TextInput
                title="Dept"
                placeholder="Please enter the Product dept!"
                inputValue={length}
                setInputValue={setLength}
              />
            </div>
          </section>

          <section className="flex flex-col md:flex-row md:space-x-4 w-full">
            <div className="w-1/2 p-2">
              <TextInput
                title="Meta Title"
                placeholder="Enter Meta Title"
                inputValue={meta_title}
                setInputValue={setMetaTitle}
              />
            </div>
            <div className="w-1/2 p-2">
              <TextInput
                title="Product URL"
                placeholder="Please enter the Product URL!"
                inputValue={productLinkName}
                setInputValue={setProductLinkName}
              />
            </div>
          </section>
          <TextAreaInput
            title="Meta Description"
            placeholder="Enter Meta Description"
            inputValue={meta_description}
            setInputValue={setMetaDescription}
          />
        </>
      ),
    },
  ];

  return (
    <Modal
      title={isUpdating ? "Update Product" : "Add Product"}
      visible={isUpdating ? isEditModal : isModalVisible}
      onCancel={handleModalCancel}
      keyboard={false}
      width={700}
      height={500}
      footer={null}
      bodyStyle={{ maxHeight: "550px", overflowY: "auto" }}>
      <Steps
        current={current}
        style={{ color: "teal" }}
        className="text-teal-800">
        {steps.map((step, index) => (
          <Step
            key={index}
            title={step.title}
            style={{ color: "teal" }}
            className="text-teal-800"
          />
        ))}
      </Steps>
      <Form form={form} layout="vertical">
        {steps[current].content}
        <div className="steps-action">
          {current > 0 && (
            <Button style={{ margin: "0 8px" }} onClick={() => prev()}>
              Previous
            </Button>
          )}
          {current < steps.length - 1 && (
            <Button
              className="bg-[#75A7AD]"
              type="primary"
              onClick={() => next()}>
              Next
            </Button>
          )}
          {current === steps.length - 1 &&
            (isUpdating ? (
              <Button
                htmlType="submit"
                className="bg-teal-800 w-230 mt-[7px]
          text-white font-semibold py-2 px-4 border
             border-gray-400 rounded shadow"
                onClick={() =>
                  handleSaveEdit({
                    name,
                    description,
                    meta_description,
                    meta_title,
                    caption,
                    image,
                    accessorylink,
                  })
                }
                loading={loading}>
                {loading ? "Updating..." : "Update Product"}
              </Button>
            ) : (
              <Button
                htmlType="submit"
                onClick={handleFormSubmit}
                loading={loading}>
                {loading ? "Adding..." : "Add Product"}
              </Button>
            ))}
        </div>
      </Form>
    </Modal>
  );
};

export default ProductModal;
